import { render, staticRenderFns } from "./FinanceClassType.vue?vue&type=template&id=497ffd8c&scoped=true&"
import script from "./FinanceClassType.vue?vue&type=script&lang=js&"
export * from "./FinanceClassType.vue?vue&type=script&lang=js&"
import style0 from "./FinanceClassType.vue?vue&type=style&index=0&id=497ffd8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ffd8c",
  null
  
)

export default component.exports